import { media } from "./media";
import { PRIMARY_CTA_HREF } from "./nav";
import { TRADEMARK, type Copy } from "./types";

export const HERO = {
  eyebrow: ["VARIANT3D · LOOP", TRADEMARK, " — software that knits"] as Copy,
  titleLines: ["Design in seconds.", "Hold in minutes."] as const,
  lede: "LOOP takes designers from intent to product with browser-based knit software built around real machine expertise.",
  note: null,
  actions: [
    { label: "Start creating", href: PRIMARY_CTA_HREF, variant: "brand" },
    { label: "See how it works", href: "#how", variant: "ghost" },
  ] as const,
  caption: "Designed in LOOP. Simulated directly from a LOOP-generated machine file.",
  viewer: {
    href: "https://spin.variant3d.io/s/share-SnDPTcKj",
    src: media("Hero.mp4"),
    poster: media("Hero.jpg"),
    alt: "A knitted performance shoe produced with LOOP, turning to reveal its knit structure.",
    gateLabel: "Explore it in 3D",
    gateHint: "Drag to orbit · Scroll to zoom",
    width: 1920,
    height: 1080,
  },
} as const;
